import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import TxtRow from "components/Custom/TxtRow";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";

import { FORMATS, NOTIFY } from "common/config";
import { LABELS, WARNINGS, TITLES, SUB_TITLES } from "common/lables";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";
import { COLORS } from "common/colors";
import { MASTER_APIs } from "apihandlers/master";
import { REPORTS_APIs } from "apihandlers/reports";

const RangeSellingCallWise = (props: any) => {
  const { setDashMenu } = props;

  const orgRef: any = useRef();

  const [loading, setLoading] = useState(true);
  const [masters, setMasters] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [columns, setColumns] = useState<any[]>([]);

  useEffect(() => {
    if (loading) {
      getOrgProfile();
    }
  }, [loading]);

  const getOrgProfile = () => {
    const args = {
      minResponse: true,
    };
    MASTER_APIs.getOrgProfiles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list: any = [{ id: -1, label: "All" }];
        let recs: any = response.records;
        for (let i = 0; i < recs.length; i++) {
          list.push({
            id: recs[i].id,
            label: recs[i].organizationName,
          });
        }
        setMasters(list);
        // setLoading(false);
      }
    });
  };

  const loadData = () => {
    const orgId = orgRef.current.selectedValue.id;
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    const args = {
      fromDt,
      toDt,
      orgId,
      reportType: "excel",
    };
    let errors = [];
    if (!orgId) {
      errors.push({
        id: "orgId",
        msg:
          "<span class='bold'>" +
          LABELS.DEALER +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (fromDt === "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt === "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    setRows(null);
    // setLoading(true);
    REPORTS_APIs.getKPIRangeSellingPerCall(args).then((res) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        for (let i = 0; i < response.rows.length; i++) {
          response.rows[i]["slNo"] = i + 1;
        }
        setRows(response.rows);
        setColumns(response.columns);
        setLoading(false);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    loadData();
  };

  console.log("Page:Range Selling Call Wise:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>{LABELS.KPI}</li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.RANGE_SELLING_CALL_WISE}</li>
        </ul>
        <h4>{TITLES.RANGE_SELLING_CALL_WISE}</h4>
        <p>{SUB_TITLES.RANGE_SELLING_CALL_WISE}</p>
      </div>
      <div className="hChart">
        <div
          style={{ width: "100%", display: "flex", flexDirection: "column" }}
        >
          <div
            className="formGroup"
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: 5,
              marginBottom: 10,
              width: "40%",
            }}
          >
            <label>{LABELS.DEALER + " :"}</label>
            <AutoComplete
              id={"masters"}
              list={masters}
              childRef={orgRef}
              defaultValue={{ id: -1, label: "All" }}
            />
          </div>
        </div>

        <div className="flexRowJustify">
          <div className="formGroup width45" style={{ marginRight: "1rem" }}>
            <TxtRow
              id={"fromDt"}
              type={"date"}
              label={LABELS.FROM_DATE}
              defaultValue={DateFunctions.getDate(
                "from",
                "from",
                FORMATS.SQL_DATE_ONLY
              )}
            />
          </div>
          <div className="formGroup width45">
            <TxtRow
              id={"toDt"}
              type={"date"}
              label={LABELS.TO_DATE}
              defaultValue={DateFunctions.getDate(
                "thismonth",
                "to",
                FORMATS.SQL_DATE_ONLY
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
              padding: 20,
              marginTop: "0.3rem",
              width: "20%",
            }}
          >
            <Btn
              text={LABELS.LOAD}
              onClick={loadData}
              bgColor={COLORS.SAVE_GREEN}
            />
          </div>
        </div>

        <div
          className="formGroup"
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: 5,
            marginBottom: 10,
            width: "40%",
          }}
        ></div>

        {mandatoryResults.length > 0 && (
          <div className="mandatoryBox">
            <ul>
              {mandatoryResults.map((m) => {
                return (
                  <li>
                    <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        <div className="grid excelGridWrapper">
          {!loading &&
            (rows ? (
              <ExcelGrid
                id={"rangeSellingCallWise"}
                height={window.innerHeight * 0.5}
                cols={columns}
                rows={rows}
                exportOption={true}
                newRowOption={false}
                exportName={LABELS.RANGE_SELLING_CALL_WISE}
                onReload={reloadGrid}
              />
            ) : (
              <div className="flexCenter" style={{ minHeight: 450 }}>
                <Loader />
              </div>
            ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(RangeSellingCallWise);
